"use client";

import { useState } from "react";
import Image from "next/image";
import PhoneInput from "react-phone-input-2";
import "../scss/messagesameer.scss";
import { contactCeo } from "@/services/publicService";
import { showError, showSuccess } from "@/utils/toast";

export default function MessageSameer() {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    company: "",
    title: "",
    phone: "",
    email: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.first_name.trim() || !formData.last_name.trim()) {
      showError("First name and last name are required");
      return;
    }
    if (!formData.email.trim()) {
      showError("Email is required");
      return;
    }
    if (!formData.phone.trim()) {
      showError("Phone number is required");
      return;
    }
    setLoading(true);
    try {
      const response = await contactCeo({ ...formData, recipient: "sameer" });
      if (response.status === 201 || response.status === 200) {
        showSuccess(response.message || "Message sent successfully!");
        setFormData({
          first_name: "",
          last_name: "",
          company: "",
          title: "",
          phone: "",
          email: "",
          message: "",
        });
      } else {
        showError(response.message || "Something went wrong");
      }
    } catch (error) {
      showError(
        error?.response?.data?.message || "An error occurred. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="message-sameer">
      {/* HERO */}
      <div className="ms-hero">
        <Image
          src="/icons/msg-bg.jpeg"
          alt="Hero"
          fill
          priority
          className="ms-hero-img"
        />

        <div className="ms-overlay">
          <h1>Message to Sameer</h1>

          <p>
            Thank you for your interest in speaking with me. Kindly complete the
            following form. I personally review every submission.
          </p>

          <div className="ms-link">
            <a href="mailto:ssomal@blueoceanglobaltech.com">
              Know More <span>→</span>
            </a>
          </div>
        </div>
      </div>

      {/* FORM */}
      <div className="ms-form-wrapper">
        <h2>Contact Information</h2>

        <p className="ms-note">* Indicates required fields</p>

        <form className="ms-form" onSubmit={handleSubmit}>
          <div className="ms-grid">
            <div className="ms-field">
              <label>First Name*</label>
              <input
                type="text"
                name="first_name"
                value={formData.first_name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="ms-field">
              <label>Last Name*</label>
              <input
                type="text"
                name="last_name"
                value={formData.last_name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="ms-field">
              <label>Company (if applicable)</label>
              <input
                type="text"
                name="company"
                value={formData.company}
                onChange={handleChange}
              />
            </div>

            <div className="ms-field">
              <label>Title</label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
              />
            </div>

            <div className="ms-field">
              <label>Phone No.*</label>
              <PhoneInput
                country={"in"}
                value={formData.phone}
                onChange={(value) =>
                  setFormData((prev) => ({ ...prev, phone: value }))
                }
                enableSearch
                countryCodeEditable={false}
                inputProps={{
                  name: "phone",
                  required: true,
                }}
                inputStyle={{
                  width: "100%",
                  height: "52px",
                  borderRadius: "8px",
                  border: "1px solid #dcdcdc",
                  fontSize: "16px",
                }}
                buttonStyle={{
                  borderTopLeftRadius: "8px",
                  borderBottomLeftRadius: "8px",
                  border: "1px solid #dcdcdc",
                }}
                containerStyle={{
                  width: "100%",
                }}
              />
            </div>

            <div className="ms-field">
              <label>Email*</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="ms-field full">
            <label>Message to Sameer</label>
            <textarea
              rows={5}
              name="message"
              value={formData.message}
              onChange={handleChange}
            ></textarea>
          </div>

          <div className="ms-btn-wrap">
            <button type="submit" disabled={loading}>
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}
